// @flow
import * as React from 'react'
import * as R from 'ramda'
import {translate} from 'react-i18next'
import {Query} from 'react-apollo'
import gql from 'graphql-tag'
import styled from 'styled-components'
import {
  Banner,
  Loading,
  Section,
  SubscriptionPricing,
  Traits,
  Trait
} from 'tutellus-ui'

import {Page} from './Page'
import {CareerShowcase} from './Careers'
import {WIPButton} from './WIPModal'

const periodicityOf = R.compose(R.toLower, R.prop('periodicity'))
const featureList = ['full_access', 'unlimited_access', 'teacher_support', 'all_certificates']
const parseOffers = R.uncurryN(2, translator => R.compose(
  R.map(R.compose(
    offer => ({
      ...offer,
      name: translator(periodicityOf(offer)),
      by_paying: translator(`${periodicityOf(offer)}_catch`),
      claim: translator(`${periodicityOf(offer)}_claim`),
      features: {
        ...R.zipObj(
          R.map(translator, featureList),
          R.values(R.pick(featureList, offer.features))
        ),
        [translator('payment_frequency')]: translator(`${periodicityOf(offer)}_frequency`)
      }
    }),
    R.head
  )),
  R.groupBy(periodicityOf)
))

const PrimaryButton = styled(WIPButton).attrs({
  primary: true,
  button: true
})``

export const SubscriptionPricingTable = translate('subscription')(({t}) =>
  <Query query={gql`{
        subscription_offers {
            periodicity
            price
            frequency
            features {
                ${featureList.join('\n')}
            }
        }
    }`}>{ ({_error, loading, data}/*: {loading: bool, data: any} */) =>
      <Loading while={loading}>{data && data.subscription_offers
        ? <SubscriptionPricing offers={parseOffers(t, data.subscription_offers)}
          period={t('period')}
          ctaText={t('purchase')}
          ctaUrl={t('urls:unlimited')}
          disclaimer={t('choose_offer_legal')}
          MyButton={PrimaryButton} />
        : null
      }</Loading>
    }</Query>
)

export const Subscription = translate('subscription')(({t}) =>
  <Page>
    <Banner title={t('title')}
      background_url={t('background_url')}>
      <p>{ t('description') }</p>
      <PrimaryButton href='#offers'>{ t('main_cta') }</PrimaryButton>
    </Banner>
    <Section title={t('reasons_title')}>
      <Traits>{
        JSON.parse(t('reasons')).map(reason =>
          <Trait key={reason}
            title={t(`${reason}_title`)}
            icon={t(`${reason}_icon`)}>
            { t(`${reason}_description`) }
          </Trait>
        )
      }</Traits>
    </Section>
    <Section id='offers' light title={t('choose_offer_title')}>
      <p>{ t('choose_offer_description') }</p>
      <SubscriptionPricingTable />
    </Section>
    <Section dark title={t('find_a_career')}>
      <CareerShowcase />
    </Section>
    <Section title={t('corporate_title')}>
      <PrimaryButton href={t('urls:corporate')}>
        { t('secondary_cta') }
      </PrimaryButton>
    </Section>
  </Page>
)
Subscription.displayName = 'Subscription'



// WEBPACK FOOTER //
// ./src/pages/Subscription.js